export default {
  "Yes": "Sí",
  "No": "No",

  "Yes, I'm Sure": "Sí, Estoy Seguro",

  "Filter": "Filtrar",
  "Record": "Registro",
  "deletedData": "Datos eliminados con éxito",
  "dataAdded": "Datos guardados correctamente",
}
